module.exports = __webpack_public_path__ + "static/media/LogicWheel3_2_2.f02395ca.png";